import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/analytics";

export default function IndustryCard({ industry }) {
  return (
    <Link
      to={`/industries/${industry.slug}`}
      data-testid={`industry-card-${industry.slug}`}
      onClick={() => track("industry_page_viewed", { industry: industry.slug })}
      className="group relative block rounded-[1.75rem] overflow-hidden border border-border-neutral bg-white"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={industry.image}
          alt={industry.alt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest/70 via-forest/10 to-transparent" />
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between">
        <span className="text-lg md:text-xl font-extrabold text-white">
          {industry.name}
        </span>
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-forest transition-transform duration-300 group-hover:rotate-45 group-hover:bg-lime">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </Link>
  );
}
